import { listenEventFromVuexToPinia, removeEventListenerFromVuexToPinia } from '@vue3/utils/vuex-event-listerner.js'
import BliLoaderGeneral from '@blibli/blue.loader-general/dist/loader-general/blue/LoaderGeneral'
import RegistrationStatusModal from '@vue3/components/auth/RegistrationStatusModal/index.vue'
import AppHeader from '@vue3/components/common/AppHeader/index.vue'
import AgreementModal from '@vue3/components/common/AgreementModal/index.vue'
import CommonStore from '@vue3/store/common-store.js'
import RejectedReason from '@vue3/components/registration/RejectedReason/index.vue'
import AuthStore from '@vue3/store/auth-store.js'
import AgreementStore from '@vue3/store/agreement-store'
import { mapActions, mapState } from 'pinia'
import { setRejectedReasonViewed, getRejectedReasonViewed, applyTheme, getLocalStorageItem } from '@vue3/utils/common'
import RegistrationStore from '@vue3/store/registration-store'
import constants from '@vue3/constants'
import NavigationBar from '@vue3/components/common/NavigationBar/index.vue'
import NpsModal from '@vue3/components/common/NpsModal/index.vue'
import NpsStore from '@vue3/store/nps-store'
import { app } from '@vue3/configs'
import CommonMixin from '@vue3/mixins/commonMixin.js'
import { requestNotificationPermissionAndGetToken, saveTokenToServer, handleNativeAppModalAcceptance } from '@vue3/firebase'
import { isAndroidAppCheck, isIOSAppCheck } from '@vue3/utils/common'
import TenantPicker from '@vue3/components/tenant/TenantPicker/index.vue'
import { pages } from '@/config'
import tracker from '@vue3/constants/tracker'

const MOBILE_WIDTH = 768
const TABLET_MIN_WIDTH = 769
const TABLET_MAX_WIDTH = 1023

const { APPROVAL_PENDING, APPROVED, EMAIL_VERIFICATION_DONE } = constants.companyRegistrationStatus

const { SYSTEM, LIGHT } = constants.theme

const { homePage, catalog, orderList, orders, orderDetail, rewards, notification, checkout, profile, mission, creditNote, rewardsDetail } = app.routerName

const { ALLOW_NOTIIFICATION, DENY_NOTIFICATION } = tracker.label

const { NOTIFICATION } = tracker.component

const navBarActiveScreens = [homePage, catalog, orderList, rewards]
const headerActiveScreens = {
  [homePage]: { desktop: true, tablet: true, mobile: true },
  [catalog]: { desktop: true, tablet: true, mobile: true },
  [orderList]: { desktop: true, tablet: true, mobile: true },
  [orders]: { desktop: true, tablet: true, mobile: true },
  [orderDetail]: { desktop: true, tablet: false, mobile: false },
  [notification]: { desktop: true, tablet: false, mobile: false },
  [rewards]: { desktop: true, tablet: true, mobile: true },
  [checkout]: { desktop: true, tablet: false, mobile: false },
  [profile]: { desktop: true, tablet: false, mobile: false },
  [mission]: { desktop: true, tablet: false, mobile: false },
  [creditNote]: { desktop: true, tablet: false, mobile: false },
  [rewardsDetail]: { desktop: true, tablet: false, mobile: false }
}
const npsRouteList = [homePage, orderDetail]
const lightThemePageList = [pages.loyalty, pages.pointsHistory, 'imeiScan/', pages.mission]

export default {
  name: 'App3',
  components: {
    NpsModal,
    TenantPicker,
    BliLoaderGeneral,
    AppHeader,
    NavigationBar,
    RejectedReason,
    RegistrationStatusModal,
    AgreementModal
  },
  mixins: [CommonMixin],
  data () {
    return {
      hasRequestedNotificationPermission: false
    }
  },
  created () {
    this.initPage()
  },
  mounted () {
    this.attachResizeHandler()
    this.adjustBodyHeight()
    this.initSystemThemeListener()
    // this.setAppLoader(true)
    // this.getApplicationConfiguration()
    listenEventFromVuexToPinia()
  },
  watch: {
    errorCode (value) {
      if (value === 401) {
        if (this.$route.meta?.auth) {
          this.setIsLoggedIn(false)
          // this.setAppLoader(true)
          // this.$router.push({ name: app.routerName.login })
        }
        // clearSessionUpdatedDate()
      }
    },
    $route () {
      // this is temp change to support IOS Legacy version
      this.sendThemeEventToiOS()
    },
    isUserLoggedInButTenantNotSelected (newValue) {
      // When the user logs in, the session is initialized during tenant selection.
      // If the user refreshes the page before selecting a tenant,
      // this ensures the flow continues by reopening the tenant picker.
      if (!newValue) {
        return
      }
      this.setShowTenantPickerModal({ showModal: true, isTenantAlreadySelected: false })
    },
    isNotificationPermissionModalVisible (newValue) {
      if (newValue && !this.hasRequestedNotificationPermission) {
        this.hasRequestedNotificationPermission = true
        this.handleNotificationPermissionRequest()
      }
    }
  },
  computed: {
    ...mapState(CommonStore, ['isMobile', 'isTablet', 'errorCode', 'showTenantPickerModal']),
    ...mapState(AuthStore, ['isLoggedIn', 'isAppConfigFetched', 'isUserFetchFinished', 'isNotificationModalVisible']),
    ...mapState(AgreementStore, ['isAgreementModalVisible']),
    ...mapState(RegistrationStore, ['isUserAlreadyVisitedReason']),
    ...mapState(NpsStore, ['showNPSPopup']),
    isRegistrationModalVisible () {
      return this.isLoggedIn && this.isUserStatusApprovedOrPending
    },
    companyRegistrationStatus () {
      return this.currentCompanyInfo?.companyRegistrationStatus || ''
    },
    isUserStatusApprovedOrPending () {
      return (this.companyRegistrationStatus === APPROVAL_PENDING || this.companyRegistrationStatus === APPROVED) && !this.showTenantPickerModal
    },
    routeName () {
      return this.$route.name
    },
    showAppHeader () {
      let screenType = this.isMobile ? 'mobile' : (this.isTablet ? 'tablet' : 'desktop')
      return headerActiveScreens[this.routeName]?.[screenType] || false
    },
    showAppBottomNabBar () {
      return !this.isDesktop && this.isRouteInNavList
    },
    isRouteInNavList () {
      return navBarActiveScreens.includes(this.routeName)
    },
    showRejectedReason () {
      return !this.showTenantPickerModal && this.companyRegistrationStatus === 'REJECTED' && !this.isUserAlreadyVisitedReason
        && !getRejectedReasonViewed(this.currentTenantId)
    },
    isNPSPopupVisible () {
      return this.appConfigs?.isNPSFeatureEnabled && this.showNPSPopup
        && npsRouteList.includes(this.routeName)
    },
    isNotificationPermissionModalVisible () {
      return !this.showTenantPicker && !this.isNPSPopupVisible && this.isNotificationModalVisible && this.companyRegistrationStatus === APPROVED && !this.currentCompanyInfo?.firstLoginPostApproval
    },
    isAgreementPopupVisible () {
      return !this.showTenantPicker && !this.isNPSPopupVisible &&
        this.isAgreementModalVisible && this.companyRegistrationStatus === APPROVED &&
        this.routeName !== app.routerName.termsAndCondition
    },
    showTenantPicker () {
      return this.showTenantPickerModal
    },
    isEmailVarificationCompleted () {
      return this.userDetails?.registrationStatus === EMAIL_VERIFICATION_DONE
    },
    hasNoCurrentCompanyInfo () {
      return !Object.keys(this.currentCompanyInfo).length
    },
    hasMappedTenants () {
      return this.tenantList?.length
    },
    isUserLoggedInButTenantNotSelected () {
      return this.isEmailVarificationCompleted && this.hasNoCurrentCompanyInfo && this.hasMappedTenants
    }
  },
  methods: {
    ...mapActions(CommonStore, ['setMobileDeviceStatus', 'setTabletDeviceStatus', 'setAppLoader', 'setShowTenantPickerModal']),
    ...mapActions(AuthStore, ['getAppConfiguration', 'setIsLoggedIn', 'setNotificationModalVisible', 'handleNotificationPermission']),
    ...mapActions(RegistrationStore, ['setIsUserAlreadyVisitedReason']),
    initPage () {
      this.handleResize()
    },
    attachResizeHandler () {
      window.addEventListener('resize', this.handleResize)
    },
    detachResizeHandler () {
      window.removeEventListener('resize', this.handleResize)
    },
    initSystemThemeListener () {
      const currentTheme = this.getThemePreferenceFromLocalStorage()
      applyTheme(currentTheme)
      const mediaQuery = window.matchMedia?.('(prefers-color-scheme: dark)')
      if (mediaQuery) {
        this.systemThemeChangeHandler = () => {
          // Always check the current theme from localStorage, not the captured value since value might change and this is an event handler
          const activeTheme = this.getThemePreferenceFromLocalStorage()
          if (activeTheme === SYSTEM) {
            applyTheme(SYSTEM)
          }
        }
        mediaQuery?.addEventListener('change', this.systemThemeChangeHandler)
        this.systemThemeMediaQuery = mediaQuery
      }
    },
    detachSystemThemeListener () {
      if (this.systemThemeMediaQuery && this.systemThemeChangeHandler) {
        this.systemThemeMediaQuery?.removeEventListener('change', this.systemThemeChangeHandler)
      }
    },
    getThemePreferenceFromLocalStorage () {
      return getLocalStorageItem('theme') || LIGHT
    },
    handleResize (currentWidth) {
      const windowWidth =
        typeof currentWidth === 'number'
          ? currentWidth
          : document.documentElement.clientWidth
      if (windowWidth <= MOBILE_WIDTH) {
        this.setMobileDeviceStatus(true)
        this.setTabletDeviceStatus(false)
      } else if (windowWidth >= TABLET_MIN_WIDTH && windowWidth <= TABLET_MAX_WIDTH) {
        this.setTabletDeviceStatus(true)
        this.setMobileDeviceStatus(false)
      } else {
        this.setMobileDeviceStatus(false)
        this.setTabletDeviceStatus(false)
      }
      this.adjustBodyHeight()
    },
    adjustBodyHeight () {
      const windowHeight = window.innerHeight
      document.body.style.height = windowHeight + 'px'
    },
    hideLoader () {
      this.setAppLoader(false)
    },
    getApplicationConfiguration () {
      const query = {
        id: 'applereseller.ui.config',
        requestId: 'apple-reseller-ui',
        clientId: 'apple-reseller-ui',
        storeId: '10001',
        channelId: this.isMobile ? 'mobile' : 'web'
      }
      this.getAppConfiguration({
        query,
        success: this.hideLoader,
        fail: this.hideLoader
      })
    },
    handleRejectedReasonClick () {
      this.setIsUserAlreadyVisitedReason(true)
      setRejectedReasonViewed(this.currentTenantId)
    },
    sendThemeEventToiOS () {
      if (!this.isIOSApp) return
      const theme = getLocalStorageItem('theme') || LIGHT
      const isLightThemePage =
        this.$route.path?.startsWith('/imeiScan/') ||
        lightThemePageList.includes(this.$route.path)
      if (isLightThemePage) {
        this.postMessageToIOSListener('SECONDARY')
        this.postMessageToIOSListener('LIGHT')
        return
      }
      if (this.showAppHeader) {
        this.postMessageToIOSListener('PRIMARY')
      } else {
        this.postMessageToIOSListener('SECONDARY')
      }
      this.postMessageToIOSListener(theme)
    },
    handleNotificationPermissionRequest () {
      const isNativeApp = isAndroidAppCheck || isIOSAppCheck

      if (isNativeApp) {
        // For native apps, set up callback and request token
        handleNativeAppModalAcceptance()
        // Close modal state
        this.setNotificationModalVisible(false)
      } else {
        // For web, request permission and get token directly
        requestNotificationPermissionAndGetToken()
          .then(token => {
            saveTokenToServer(token)
            this.setNotificationModalVisible(false)
            const trackValue = {
              cp1: ALLOW_NOTIIFICATION,
              cp2: this.userDetails.email,
              trms_id: 'DEV-001'
            }
            this.$trackButtonClick(NOTIFICATION, trackValue)
          })
          .catch(() => {
            // User denied permission - just close modal
            this.setNotificationModalVisible(false)
            const trackValue = {
              cp1: DENY_NOTIFICATION,
              cp2: this.userDetails.email,
              trms_id: 'DEV-001'
            }
            this.$trackButtonClick(NOTIFICATION, trackValue)
          })
      }
    }
  },
  beforeUnmount () {
    this.detachResizeHandler()
    this.detachSystemThemeListener()
    removeEventListenerFromVuexToPinia()
  }
}
